module.exports = __webpack_public_path__ + "img/zfb_1.938c62de.png";